module.exports = __webpack_public_path__ + "static/media/Hospitality_13.48445576.jpg";